module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "layout-top"
  }, [_c('header', {
    staticClass: "header header-opacity header-search"
  }, [_c('div', {
    staticClass: "header-body"
  }, [_c('bo-input', {
    attrs: {
      "size": "sm",
      "icon": "search",
      "holder": "请输入搜索内容"
    }
  })], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "layout-main"
  }, [_c('slide', {
    attrs: {
      "surface": [{
          imgUrl: 'http://mlo.jishi88.com/dist/v1.3.7/2.png?870bbc643c89ab370522a8eea9cf4985'
        },
        {
          imgUrl: 'http://mlo.jishi88.com/dist/v1.3.7/1.png?99a3d4cc476cce3ed4826cd912b12876'
        },
        {
          imgUrl: 'http://mlo.jishi88.com/dist/v1.3.7/3.png?b13d9da72fe03c029ff79e1720a318b7'
        }
      ]
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('toast', {
    ref: "toast",
    attrs: {
      "type": _vm.type,
      "content": _vm.content
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bor-bottom bor-top p2020",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('nav', {
    staticClass: "menu-horizon menu-horizon-circle  "
  }, [_c('button', {
    staticClass: "menu-horizon-item"
  }, [_c('span', {
    staticClass: "menu-pic",
    staticStyle: {
      "background": "#FFB30F"
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-creative"
  })]), _vm._v(" "), _c('span', {
    staticClass: "menu-title"
  }, [_vm._v("肉类精选")])]), _vm._v(" "), _c('button', {
    staticClass: "menu-horizon-item"
  }, [_c('span', {
    staticClass: "menu-pic",
    staticStyle: {
      "background": "#34ad8f"
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-scan"
  })]), _vm._v(" "), _c('span', {
    staticClass: "menu-title"
  }, [_vm._v("粮油米面")])]), _vm._v(" "), _c('button', {
    staticClass: "menu-horizon-item"
  }, [_c('span', {
    staticClass: "menu-pic",
    staticStyle: {
      "background": "#3492e6"
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-favor"
  })]), _vm._v(" "), _c('span', {
    staticClass: "menu-title"
  }, [_vm._v("果蔬副食")])]), _vm._v(" "), _c('button', {
    staticClass: "menu-horizon-item"
  }, [_c('span', {
    staticClass: "menu-pic",
    staticStyle: {
      "background": "#FFB30F"
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-favor"
  })]), _vm._v(" "), _c('span', {
    staticClass: "menu-title"
  }, [_vm._v("名茶名酒")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bor-bottom bor-top p0020",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('nav', {
    staticClass: "menu-horizon menu-horizon-circle"
  }, [_c('button', {
    staticClass: "menu-horizon-item"
  }, [_c('span', {
    staticClass: "menu-pic",
    staticStyle: {
      "background": "#FFB30F"
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-creative"
  })]), _vm._v(" "), _c('span', {
    staticClass: "menu-title"
  }, [_vm._v("野生特产")])]), _vm._v(" "), _c('button', {
    staticClass: "menu-horizon-item"
  }, [_c('span', {
    staticClass: "menu-pic",
    staticStyle: {
      "background": "#3492e6"
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-scan"
  })]), _vm._v(" "), _c('span', {
    staticClass: "menu-title"
  }, [_vm._v("水产极品")])]), _vm._v(" "), _c('button', {
    staticClass: "menu-horizon-item"
  }, [_c('span', {
    staticClass: "menu-pic",
    staticStyle: {
      "background": "#34ad8f"
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-favor"
  })]), _vm._v(" "), _c('span', {
    staticClass: "menu-title"
  }, [_vm._v("滋补保健")])]), _vm._v(" "), _c('button', {
    staticClass: "menu-horizon-item"
  }, [_c('span', {
    staticClass: "menu-pic",
    staticStyle: {
      "background": "#34ad8f"
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-favor"
  })]), _vm._v(" "), _c('span', {
    staticClass: "menu-title"
  }, [_vm._v("工艺礼品")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-347220be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/other/seller/seller.vue
// module id = 238
// module chunks = 2